import { DataViewValueList } from './models/DataViewValueList';

/**
 * 日時を指定したフォーマットで文字列に変換します。
 * @param date フォーマットする日時オブジェクトを指定します。
 * @param format 日時フォーマットを指定します。
 * @returns フォーマットした日時を文字列で返します。
 */
const formatDate = (date: Date, format: string) => {
    format = format.replace(/yyyy/g, date.getFullYear().toString());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
    return format;
}

/**
 * 指定したURLにリダイレクトをします。
 * @param url リダイレクト先を指定します。
 */
const redirectTo = (url: string) => {
    document.location.href = url;
}

/**
 * データ表示用に読み込んだデータモデルを変換します。
 * @param data 変換するデータモデルを指定します。
 * @returns 表示用のヘッダーとcreated_atごとにグループ化した値一覧を返します。
 */
const convertDataForDataView = (data: any[]): [string[], DataViewValueList] => {
    const header: string[] = [];
    const valueList: DataViewValueList = {};

    header.push('created_at');


    data.forEach((row) => {
        const createdAt = row['created_at'];
        const rowValues = [];

        for (const key in row) {
            const isExsists = header.includes(key);

            if (key !== 'created_at') {
                rowValues.push(row[key]);

                if (isExsists === false) {
                    header.push(key);
                }
            }
        }

        valueList[createdAt] = rowValues;
    });

    return [header, valueList];
};

export { formatDate, redirectTo, convertDataForDataView };